import { useQuery } from '@tanstack/react-query'
import { recordingQueryOptions } from '@/entities/recording'

// Запись аудио стартует на бэке автоматически (webhook participant_joined) —
// фронт только опрашивает статус стабильным интервалом: индикатор «идёт
// запись» видят все участники. 404 = записи ещё нет.
export function useRecording(meetingId: string, enabled = true) {
  return useQuery({
    ...recordingQueryOptions(meetingId),
    enabled,
    retry: false,
    refetchInterval: 6000,
  })
}

export function isRecordingActive(state: string | undefined): boolean {
  return state === 'recording'
}
